import { useDispatch, useSelector } from 'react-redux';
import { roleActions } from '../../../redux/Role';
import { rolesCodes } from '../../../constants/Roles';
import { useEffect } from 'react';

function SceltaRuolo() {
  const dispatch = useDispatch();

  const roles = useSelector((state) => state.role);

  useEffect(() => {
    sessionStorage.removeItem('/gestione-adesione-enti_filtri_avanzati');
    sessionStorage.removeItem('/gestione-adesione-enti_options');

    sessionStorage.removeItem('/gestione-operatori');
    sessionStorage.removeItem('/gestione-operatori_options');

    sessionStorage.removeItem('/gestione-avvisi_options');

    sessionStorage.removeItem('/gestione-fasi_options');

    sessionStorage.removeItem('/gestione-indirizzi-studio_filtri_avanzati');
    sessionStorage.removeItem('/gestione-indirizzi-studio_options');
  }, []);

  const changeRole = (role) => {
    dispatch(roleActions.setRoleSelected(role));
  };

  const changeEnte = (ente) => {
    const referente = roles.referenze.find(r => r.id === ente.id);
    dispatch(roleActions.setRoleSelected(referente ? rolesCodes.comuneReferente : rolesCodes.comune));
    dispatch(roleActions.setEnteSelected(ente.id));
  };

  const checkCorrectRoleName = (role) => {
    switch (role) {
      case 'COMUNE':
      case 'COMUNE_REFERENTE':
        return 'Comune';
      case 'REGIONE':
        return 'Regione Toscana';
      case 'ADMIN':
        return 'Admin';
      default:
        return 'Cittadino';
    }
  };

  const checkCorrectComuneRoleName = (ente, type) => {
    return type + ente.denominazione;
  };

  const getRoleIcon = (role) => {
    switch (role) {
      case 'COMUNE':
      case 'COMUNE_REFERENTE':
        return `${process.env.PUBLIC_URL}/icons.svg#solid--building-library`;
      case 'REGIONE':
        return `${process.env.PUBLIC_URL}/icons.svg#solid--building-library`;
      case 'ADMIN':
        return `${process.env.PUBLIC_URL}/icons.svg#solid--shield`;
      case 'CITTADINO':
        return `${process.env.PUBLIC_URL}/icons.svg#solid--user`;
      default:
        return `${process.env.PUBLIC_URL}/icons.svg#solid--building-library`;
    }
  };

  return (
    <>
      <div className='rtds-container-xxs rtds-py-6'>
        <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
          <div className='rtds-flex rtds-items-center rtds-justify-between'>
            <h1 className='rtds-heading-2'>Ruolo</h1>
          </div>
          <div>
            <p className='rtds-body-xl'>Scegli il ruolo con cui accedere</p>
          </div>
          <div className='rtds-flex rtds-justify-center'>
            <div className='rtds-w-full'>
              {
                roles?.authorities?.filter(r => r === rolesCodes.cittadino || r === rolesCodes.regione || r === rolesCodes.admin).map((opt) => (
                  <button
                    type='button'
                    key={opt}
                    className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary rtds-form-submit'
                    onClick={() => changeRole(opt)}
                  >
                    <svg
                      className='rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:-rtds-translate-x-1'
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use xlinkHref={getRoleIcon(opt)} />
                    </svg>
                    {checkCorrectRoleName(opt)}
                  </button>
                ))
              }
              {
                roles?.referenze?.map((opt) => (
                  <button
                    type='button'
                    key={opt.id}
                    className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary rtds-form-submit'
                    onClick={() => changeEnte(opt)}
                  >
                    <svg
                      className='rtds-icon rtds-fill-current rtds-transition-all group-hover/button:-rtds-translate-x-1 rtds-w-5 rtds-h-5 '
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use xlinkHref={getRoleIcon(opt)} />
                    </svg>
                    {checkCorrectComuneRoleName(opt, 'Comune di ')}
                  </button>
                ))
              }
              {
                roles?.operatori?.map((opt) => (
                  <button
                    type='button'
                    key={opt.id}
                    className='rtds-w-full rtds-mb-5 rtds-justify-center rtds-btn rtds-btn--icon-left rtds-group/button rtds-btn--primary rtds-form-submit'
                    onClick={() => changeEnte(opt)}
                  >
                    <svg
                      className='rtds-icon rtds-fill-current rtds-transition-all group-hover/button:-rtds-translate-x-1 rtds-w-5 rtds-h-5 '
                      aria-hidden='true'
                      focusable='false'
                      role='img'
                    >
                      <use xlinkHref={getRoleIcon(opt)} />
                    </svg>
                    {checkCorrectComuneRoleName(opt, 'Comune di ')}
                  </button>
                ))
              }
            </div>
          </div>
           {/*<div>
            <p className='rtds-text-center '>
              Per eventuali quesiti è possibile inoltrare una mail a <a className='rtds-link ' href='mailto:librigratis@regione.toscana.it'>librigratis@regione.toscana.it</a>
            </p>
          </div>*/}
        </div>
      </div>
    </>
  );
}

export default SceltaRuolo;
